module.exports = __webpack_public_path__ + "img/box9-11.c301fce5.png";